export default __webpack_public_path__ + "static/media/back_arrow.3a0b2dbf.svg";